// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetIssuuDocumentCoverRequestModel from '../../model/get-issuu-document-cover-request-model';
import GetIssuuDocumentCoverRequestDTO from '../dto/get-issuu-document-cover-request-dto';
import dtoSchema from '../schemas/get-issuu-document-cover-request-schema';

export default abstract class GetIssuuDocumentCoverRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetIssuuDocumentCoverRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  */
  id?: string;

  static toModel(dto: DeepPartial<GetIssuuDocumentCoverRequestDTO>): GetIssuuDocumentCoverRequestModel;
  static toModel(dto: DeepPartial<GetIssuuDocumentCoverRequestDTO> | undefined | null): GetIssuuDocumentCoverRequestModel | undefined;
  static toModel(dto: DeepPartial<GetIssuuDocumentCoverRequestDTO> | undefined | null): GetIssuuDocumentCoverRequestModel | undefined {
    return dto ? new GetIssuuDocumentCoverRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetIssuuDocumentCoverRequestModel> | GetIssuuDocumentCoverRequestModel): GetIssuuDocumentCoverRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetIssuuDocumentCoverRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetIssuuDocumentCoverRequestModel, can not map to GetIssuuDocumentCoverRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
